import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'sp0005',
    ecrans: ['00-2'],
    params: ['id',
             '?demcleint'  ]
});
